var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-form',{attrs:{"loading":_vm.isLoading,"product":_vm.product},on:{"on-submit":_vm.onSave,"close":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }